import { AddressyItem } from '../../core/interfaces/addressy/api/address/retrieve-api.interface';
import { BaseWooCommerceAddressDetails } from '../../core/interfaces/woo-commerce/woo-commerce.interface';

export const convertAddressy2WooCommerce = (
  addressyAddress: AddressyItem
): BaseWooCommerceAddressDetails => ({
  address: addressyAddress.Label,
  address_1: addressyAddress.Line1,
  address_2: addressyAddress.Line2,
  country: addressyAddress.CountryIso2,
  state: addressyAddress.ProvinceCode,
  city: addressyAddress.City,
  postcode: addressyAddress.PostalCode.split('-')[0]
});
